import * as React from "react";
import { getPriorityName } from "logic/alerts/EventDefinitionPriorityEnum";
const PriorityName = ({ priority }) => /* @__PURE__ */ React.createElement(React.Fragment, null, getPriorityName(priority));
export default PriorityName;
